import { type NavItem, navItems } from "@/components/layout/nav-items";

/** Where each v1 page lives. Typed as string so a link can name a page before its route exists. */
export const PAGE_HREFS: Record<"time" | "guidance" | "pto" | "expenses", string> = {
  time: "/dashboard/time",
  guidance: "/dashboard/guidance",
  pto: "/dashboard/pto",
  expenses: "/dashboard/expenses",
};

/**
 * Feature gate for links into other pages (Home's PTO request / Expense buttons and their
 * tiles). The nav lists built pages only, so a page is live exactly when it is in navItems:
 * adding the nav item is what turns the button on.
 */
export function isPageBuilt(href: string, items: readonly NavItem[] = navItems): boolean {
  return items.some((item) => item.href === href);
}
